import {
  APPEND_NPWP_DETAIL_ERROR_MESSAGES,
  DO_APPROVE_NPWP,
  DO_REJECT_NPWP,
  DO_SET_NPWP_STATUS_PENDING,
  LOAD_NPWP_BUSINESS_DETAIL,
  LOAD_NPWP_BUSINESS_LIST,
  SET_NPWP_APPROVE_MODAL_LOADING,
  SET_NPWP_APPROVE_MODAL_SHOWN,
  SET_NPWP_BUSINESS_LIST,
  SET_NPWP_BUSINESS_LIST_IS_LOADING,
  SET_NPWP_DETAIL_APPROVAL_LOGS,
  SET_NPWP_DETAIL_BUSINESS_DETAILS,
  SET_NPWP_DETAIL_ERROR_MESSAGES,
  SET_NPWP_DETAIL_LOADING_STATES,
  SET_NPWP_DETAIL_MODAL_SHOWN,
  SET_NPWP_DETAIL_NPWP_DETAILS,
  SET_NPWP_EDIT_MODAL_LOADING,
  SET_NPWP_EDIT_MODAL_SHOWN,
  SET_NPWP_LIST_FILTERS,
  SET_NPWP_REJECT_MODAL_LOADING,
  SET_NPWP_REJECT_MODAL_SHOWN,
  SET_NPWP_REVIEW_DETAILS_MODAL_LOADING,
  SET_NPWP_REVIEW_DETAILS_MODAL_SHOWN,
  SUBMIT_EDIT_NPWP,
} from 'state/actionTypes';

export const setNpwpBusinesListIsLoading = isLoading => ({
  type: SET_NPWP_BUSINESS_LIST_IS_LOADING,
  payload: { isLoading },
});

export const setNpwpBusinessesList = (list, { page, size, total }) => ({
  type: SET_NPWP_BUSINESS_LIST,
  payload: { list, page, size, total },
});

export const loadNpwpBusinessList = (filters, paging) => ({
  type: LOAD_NPWP_BUSINESS_LIST,
  payload: { filters, paging },
});

export const setNpwpListFilters = ({
  startCreatedDate,
  endCreatedDate,
  npwpStatus,
  searchKeyword,
  searchBy,
}) => ({
  type: SET_NPWP_LIST_FILTERS,
  payload: {
    startCreatedDate,
    endCreatedDate,
    npwpStatus,
    searchKeyword,
    searchBy,
  },
});

export const setNpwpDetailModalShown = shown => ({
  type: SET_NPWP_DETAIL_MODAL_SHOWN,
  payload: { shown },
});

export const loadNpwpBusinessDetail = businessId => ({
  type: LOAD_NPWP_BUSINESS_DETAIL,
  payload: { businessId },
});

export const setNpwpDetailErrorMessages = errorMessages => ({
  type: SET_NPWP_DETAIL_ERROR_MESSAGES,
  payload: { errorMessages },
});

export const clearNpwpDetailErrorMessages = () =>
  setNpwpDetailErrorMessages([]);

export const appendNpwpDetailErrorMessages = errorMessages => ({
  type: APPEND_NPWP_DETAIL_ERROR_MESSAGES,
  payload: { errorMessages },
});

export const setNpwpDetailLoadingStates = loadingStates => ({
  type: SET_NPWP_DETAIL_LOADING_STATES,
  payload: { loadingStates },
});

export const resetNpwpDetailLoadingStates = () =>
  setNpwpDetailLoadingStates({
    business: false,
    npwp: false,
    log: false,
  });

export const setNpwpDetailBusinessDetails = business => ({
  type: SET_NPWP_DETAIL_BUSINESS_DETAILS,
  payload: { business },
});

export const setNpwpDetailNpwpDetails = npwp => ({
  type: SET_NPWP_DETAIL_NPWP_DETAILS,
  payload: { npwp },
});

export const setNpwpDetailApprovalLogs = approvalLogs => ({
  type: SET_NPWP_DETAIL_APPROVAL_LOGS,
  payload: { approvalLogs },
});

export const clearNpwpApprovalLogs = () =>
  setNpwpDetailApprovalLogs({ last_log: null, logs: [] });

export const setNpwpApproveModalShown = shown => ({
  type: SET_NPWP_APPROVE_MODAL_SHOWN,
  payload: { shown },
});

export const setNpwpApproveModalLoading = isLoading => ({
  type: SET_NPWP_APPROVE_MODAL_LOADING,
  payload: { isLoading },
});

export const doApproveNpwp = businessId => ({
  type: DO_APPROVE_NPWP,
  payload: { businessId },
});

export const setNpwpRejectModalShown = shown => ({
  type: SET_NPWP_REJECT_MODAL_SHOWN,
  payload: { shown },
});

export const setNpwpRejectModalLoading = isLoading => ({
  type: SET_NPWP_REJECT_MODAL_LOADING,
  payload: { isLoading },
});

export const doRejectNpwp = (businessId, reason) => ({
  type: DO_REJECT_NPWP,
  payload: { businessId, reason },
});

export const doSetNpwpStatusPending = businessId => ({
  type: DO_SET_NPWP_STATUS_PENDING,
  payload: { businessId },
});

export const setNpwpReviewDetailsModalShown = shown => ({
  type: SET_NPWP_REVIEW_DETAILS_MODAL_SHOWN,
  payload: { shown },
});

export const setNpwpReviewDetailsModalLoading = isLoading => ({
  type: SET_NPWP_REVIEW_DETAILS_MODAL_LOADING,
  payload: { isLoading },
});

export const setNpwpEditModalShown = shown => ({
  type: SET_NPWP_EDIT_MODAL_SHOWN,
  payload: { shown },
});

export const setNpwpEditModalLoading = isLoading => ({
  type: SET_NPWP_EDIT_MODAL_LOADING,
  payload: { isLoading },
});

export const submitEditNpwp = (businessId, form) => ({
  type: SUBMIT_EDIT_NPWP,
  payload: { businessId, form },
});
